var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input_container",
      class: _vm.containerClass,
      on: {
        mouseenter: function ($event) {
          _vm.hovering = true
        },
        mouseleave: function ($event) {
          _vm.hovering = false
        },
      },
    },
    [
      _vm._t("prepend"),
      _vm._v(" "),
      _c("div", { staticClass: "input_wrap" }, [
        _vm.searchable
          ? _c("div", { staticClass: "search", on: { click: _vm.search } }, [
              _c("span", { staticClass: "iconfont icon-quick-search-block" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "input",
          _vm._b(
            {
              ref: "input",
              staticClass: "input",
              class: _vm.inputClass,
              attrs: { disabled: _vm.inputDisabled, readonly: _vm.readonly },
              on: {
                focus: _vm.handleFocus,
                blur: _vm.handleBlur,
                change: _vm.handleChange,
                input: _vm.handleInput,
                compositionstart: _vm.handleCompositionStart,
                compositionend: _vm.handleCompositionEnd,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.$emit("enter")
                },
              },
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showClear,
                expression: "showClear",
              },
            ],
            staticClass: "clear",
            on: { click: _vm.clear },
          },
          [_c("span", { staticClass: "iconfont icon-clear_circle_outlined" })]
        ),
      ]),
      _vm._v(" "),
      _vm._t("append"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }